import { useQuery } from "@tanstack/react-query";
import { mcpClient } from "../../lib/mcp-client";

/**
 * Sprint 14g — fetch inbound references to an item, backing the confirm-delete
 * modal's "referenced by N things" surface. Wraps the `get_back_references` MCP
 * tool. Disabled until a kind + id are provided (so it only fires when a delete
 * modal opens).
 */

export interface BackRef {
  kind: string;
  name: string;
  id: string;
  location: string;
}

export interface BackRefSummary {
  count: number;
  refs: BackRef[];
  truncated: boolean;
  scanned_cap: number;
}

const EMPTY: BackRefSummary = { count: 0, refs: [], truncated: false, scanned_cap: 1000 };

export function useBackRefs(
  kind: string | undefined,
  id: string | undefined,
  enabled = true,
) {
  return useQuery<BackRefSummary>({
    queryKey: ["back-refs", kind, id],
    queryFn: async () => {
      const r = await mcpClient.toolsCall<BackRefSummary>("get_back_references", { kind, id });
      if (r.isError) throw new Error(r.content?.[0]?.text ?? "Failed to fetch references");
      return r.structuredContent ?? EMPTY;
    },
    enabled: enabled && !!kind && !!id,
    staleTime: 5_000,
  });
}
